/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */

export var isIpadOS = function isIpadOS() {
  try {
    var ua = window.navigator.userAgent.toLowerCase();
    return /(ipad)/.test(ua) || /macintosh|mac os x/i.test(ua) && navigator.maxTouchPoints > 2;
  } catch (e) {
    return false;
  }
};
export var isAndroidPhone = function isAndroidPhone() {
  try {
    var ua = window.navigator.userAgent.toLowerCase();
    return !!ua.match(/android/) && !!ua.match(/mobile/);
  } catch (e) {
    return false;
  }
};
export var isPhone = function isPhone() {
  try {
    var ua = window.navigator.userAgent.toLowerCase();
    return !!ua.match(/(micromessenger|webbrowser|windows whone|blackberry|ipod|iphone|webos)/) || isAndroidPhone();
  } catch (e) {
    return false;
  }
};
export var isIOS = function isIOS() {
  try {
    return !!navigator.userAgent.toLowerCase().match(/(ipod|iphone)/);
  } catch (e) {
    return false;
  }
};
export var isTablet = function isTablet() {
  try {
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(window.navigator.userAgent.toLowerCase()) || isIpadOS();
  } catch (e) {
    return false;
  }
};
export var isTouchDevices = function isTouchDevices() {
  return isPhone() || isTablet();
};
export function isWin() {
  try {
    var userAgent = navigator.userAgent.toLowerCase();
    var windowsPlatforms = /(win32|win64|windows|wince)/i;
    return windowsPlatforms.test(userAgent);
  } catch (e) {
    return false;
  }
}